import { Component, OnInit, DestroyRef, inject, ViewChild, ViewContainerRef, Output, EventEmitter, Renderer2, AfterViewInit } from '@angular/core';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, Subscription, combineLatest, filter, finalize, map, mergeMap, of, take } from 'rxjs';
import { InstancesService } from 'src/app/services/api/instances.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import {
  ConfigurationApplicationStatus, ConfigurationPackageStatus,
  ConfigurationState
} from 'src/app/models/configurations/configuration-state';
import { Configuration } from 'src/app/models/configurations/configuration';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { Solution } from 'src/app/models/service/solution';
import { RouterSegments } from 'src/app/models/router-segments';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { EnvironmentPages } from 'src/app/models/environment-pages/environment-pages';
import { TenantService } from 'src/app/services/api/tenant.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ScrollService } from 'src/app/services/util/scroll.service';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { LocalConfiguration } from 'src/app/services/api/local-config.service';
import { TourService } from 'src/app/services/util/tour.service';
import { ENV_NAV_TOUR_STEPS } from 'src/assets/config/tour/env-nav-tour-steps';
import { isReleaseVersion } from 'src/app/services/util/utils';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';

@Component({
  selector: 'app-environment-details',
  templateUrl: './environment-details.component.html',
  styleUrl: './environment-details.component.scss',
  standalone: false,
})

export class EnvironmentDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  @Output() goToJobsPage = new EventEmitter<any>();
  private destroyRef = inject(DestroyRef);
  sidebarCollapsed = false;
  breadcrumbItems: BreadcrumbItem[];
  instanceId: string;
  data: any;
  tenantId: string;
  getBlueprints: any;
  solutionVersions: any[];
  solutionVersion: any;
  serviceVersions: SolutionVersion[];
  viewReleaseNotes: string;
  DeployStatus = DeployStatus;
  releasePackage: any;
  configurations: Configuration[];
  service: Solution;
  RouterSegments = RouterSegments;
  fromCU = false;
  fromDR = false;
  solutionId: any;
  blueprintId: any;
  component: any;
  solVersion: string;
  EnvironmentPages = EnvironmentPages;
  hasSecondaryRegion: boolean;
  tenantDetails: any;
  isLoading = true;
  isAWS: boolean;
  count: number;
  isHeaderRefreshing = false;
  isOverviewRefreshing = false;
  cloudProvider: any;
  configVersion: any;
  sizingApplyInprogress: boolean = false;
  sizingHasBeenInitializing: boolean = false;
  showTableView: boolean | null = null;
  initStatus: string | null = null;
  fetchMigrateFailed: boolean = false;
  shouldInitLocalConfig = false;
  isExternalTenant: boolean = false;
  tenantOriginChecked = false;
  instanceFeatureResponse: any;

  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.TESTING,
    DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.STARTING_AGENT,
    DeployStatus.STOPPING_AGENT,
    DeployStatus.STARTING,
    DeployStatus.STOPPING
  ];
  selectedScheduleJob: any;

  readonly INSTANCE_STATUS_FAILED = [DeployStatus.FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.INITIALIZE_FAILED,DeployStatus.TEST_FAILED, 
      DeployStatus.FAILBACK_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.FAILOVER_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED,
      DeployStatus.STOP_FAILED, DeployStatus.START_FAILED, DeployStatus.TERMINATION_FAILED];

  statusIcons = {
    deployed: 'done',
    initialized: 'done',
    updated: 'done',
    failed: 'close',
    configuration_failed: 'close',
    terminated: 'error_outline',
    termination_failed: 'close',
    initialization_failed: 'close',
    test_failed: 'close',
    stopped: 'error_outline',
    start_failed: 'close',
    stop_failed: 'close',
    inprogress: 'change_circle',
    operation_inprogress: 'change_circle',
  };
  switchToNewViewForAzure: boolean;
  isReleaseGreaterOrEqual  = isReleaseVersion;
  showTourIntro = false;

  private readonly TOUR_DISMISSED_KEY_AZURE = 'env-nav-tour-intro-dismissed-azure';
  private readonly TOUR_DISMISSED_KEY_AWS = 'env-nav-tour-intro-dismissed-aws';
  subscriptionData: any;
   private featureFlagsManagerService = inject(FeatureFlagsManagerService);


  constructor(
    private instanceService: InstancesService,
    private toastrService: CustomToastrService,
    private activatedRoute: ActivatedRoute,
    private blueprintsService: BlueprintsService,
    private solutionsService: SolutionsService,
    private configService: ConfigurationsService,
    public authService: AuthService,
    private sidenavService: SidenavService,
    private tenantService: TenantService,
    private scrollService: ScrollService,
    private renderer: Renderer2,
    private router: Router,
    private localConfigService: LocalConfiguration,
    private tourService: TourService
  ) { }
  ngOnInit(): void {
    this.tenantService.tenant$
    .pipe(
      filter((tenant) => tenant != null),
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(tenant => {
      this.isExternalTenant = tenant?.origin === TenantOrigin.EXTERNAL;
      this.tenantOriginChecked = true;
    });      
    this.renderer.addClass(document.body, 'env-details-no-scroll');
    this.component = EnvironmentPages.OVERVIEW;
    if (history.state.data === EnvironmentPages.RUNBOOK) {
      this.component = EnvironmentPages.RUNBOOK;
    } else if(history.state.data === EnvironmentPages.SCHEDULES) {
      this.component = EnvironmentPages.SCHEDULES;
    } else if(history.state.data === EnvironmentPages.JOBS) {
      this.component = EnvironmentPages.JOBS;
    } else if(history.state.data === EnvironmentPages.SIZING_DOCUMENTS) {
      this.component = EnvironmentPages.SIZING_DOCUMENTS;
    } else if(history.state.data === EnvironmentPages.BASE_IMAGE) {
      this.component = EnvironmentPages.BASE_IMAGE;
    }
    this.breadcrumbItems = [];
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.cloudProvider = data;
      this.isAWS = data === CloudProvider.AWS ? true : false;
      const tourKey = data === CloudProvider.AWS ? this.TOUR_DISMISSED_KEY_AWS : data === CloudProvider.AZURE ? this.TOUR_DISMISSED_KEY_AZURE : null;
      if (tourKey && !localStorage.getItem(tourKey)) {
        setTimeout(() => { this.showTourIntro = true; }, 800);
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.fromCU = params['fromCU'] === 'true';
      this.fromDR = params['fromDR'] === 'true';
      this.sidenavService.tenantSelectedMenu = this.fromCU
        ? 'TENANT_LAYOUT.MENU.CONTINUOUS_UPDATE'
        : this.fromDR ? 'TENANT_LAYOUT.MENU.DISASTER_RECOVERY' : 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
    });
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.getTenantDetails();
    this.getInstanceDetails();
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.configService.getConfigurations(blueprintId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(configurations => {
     this.configurations = configurations;
     this.getReleasePackage();
    })
    this.getAllFeatureByInstanceid(this.instanceId);
  }

  ngAfterViewInit(): void {
  }

  private getTourDismissedKey(): string | null {
    if (this.cloudProvider === CloudProvider.AWS) { return this.TOUR_DISMISSED_KEY_AWS; }
    if (this.cloudProvider === CloudProvider.AZURE) { return this.TOUR_DISMISSED_KEY_AZURE; }
    return null;
  }

  startNavTour(): void {
    this.showTourIntro = false;
    const key = this.getTourDismissedKey();
    if (key) { localStorage.setItem(key, 'true'); }
    this.tourService.setEnabled(true);
    this.tourService.start(ENV_NAV_TOUR_STEPS);
  }

  dismissNavTour(): void {
    this.showTourIntro = false;
    const key = this.getTourDismissedKey();
    if (key) { localStorage.setItem(key, 'true'); }
  }

  handleToggle() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  loadComponent(component: string) {
    this.component = component;
    if (component === EnvironmentPages.LOCAL_CONFIGURATION) {
      this.shouldInitLocalConfig = true;
       this.tryInitLocalConfig();
    }
    this.scrollService.scrollToTop();
  }

  getTenantDetails() {
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.tenantService.getTenantDetails(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.tenantDetails = data;
        if(data?.parameters?.hasSecondaryRegion && (data?.parameters?.hasSecondaryRegion === 'true' || data?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if (!data?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
      });
  }

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.data.solution = data;
          if (this.sizingApplyInprogress) {
            if (data?.status === DeployStatus.INITIALIZING) {
              this.sizingHasBeenInitializing = true;
            } else if (this.sizingHasBeenInitializing) {
              this.sizingApplyInprogress = false;
              this.sizingHasBeenInitializing = false;
            }
          }
          this.loadService();
          this.isHeaderRefreshing = false;
          this.isOverviewRefreshing = false;
          this.getTenantAccountDetails();
          //fetch localconfig details
          /*if (this.data?.localConfigurationId) {
            this.getLocalConfiguration();
          }*/
          this.getLocalConfiguration();
        }
      },
        (error) => {
        setTimeout(() => {
          this.isHeaderRefreshing = false;
          this.isOverviewRefreshing = false;
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  getTenantAccountDetails(): void {
  this.tenantService.getTenantAccountDetails(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (data: any) => {
        this.subscriptionData = data;
        if (data) {
          const filtered = data.find(
            (item: any) => item.dataZone === this.data?.dataZone
          );
          if (filtered && !this.isAWS) {
            this.data.subscriptionId =
              filtered.azureDetails?.subscriptionId;
          }
        }
      },
      error: (error: any) => {
        setTimeout(() => {
		    const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
        }, 500);
      }
    });
}

  private loadService(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.blueprintsService.getBlueprints(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((blueprints: any) => {
      this.getBlueprints = blueprints?.find(item => item.id == blueprintId);
      const solutionId = this.getBlueprints?.solutionId;
      if (this.fromCU) {
          // Show Continuous Update breadcrumbs
          this.breadcrumbItems = [
            { icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
            { label: translate('TENANT_CONTINUOUS_UPDATE.CONTINUOUS_UPDATE'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE] },
            { label: this.getBlueprints?.name, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
               RouterSegments.BLUEPRINTS, this.getBlueprints?.id] },
            { label: this.data.name }
          ];
        } else if (this.fromDR) {
          // Show Disaster recovery breadcrumbs
          this.breadcrumbItems = [
            { icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
            { label: translate('TENANT_LAYOUT.MENU.DISASTER_RECOVERY'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.DISASTER_RECOVERY] },
            { label: this.getBlueprints?.name, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.DISASTER_RECOVERY,RouterSegments.BLUEPRINTS, this.getBlueprints?.id] },
            { label: this.data.name }
          ];
        }
         else {
          // Default Service Definition breadcrumbs
          this.breadcrumbItems = [
            { icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
            { label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION] },
            { label: this.getBlueprints?.name, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.getBlueprints?.id] },
            { label: this.data.name }
          ];
        }
      if (solutionId) {
        combineLatest([this.solutionsService.getSolutionDetailsById(solutionId), this.solutionsService.getSolutionVersions(solutionId)])
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(([service, serviceVersions]) => {
            this.service = service;
            this.serviceVersions = serviceVersions;
            this.solVersion = this.getSolVersion(this.data.solutionVersionId);
            this.getBuildVersion(this.data?.solutionVersionId);
            this.tryInitLocalConfig();
            if (this.solutionVersions) {
              this.viewReleaseNotes = this.solutionVersions[this.solutionVersions?.length - 1]?.releaseNotes;
            }
          }, (error) => {
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
              this.toastrService.errMessage(message, title);
            }, 500);
          });
      }
    });
  }

  getReleasePackage(): void {
    this.configService.getConfigurationStates(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(configurationStates => {
      const sortedConfigurationStates = configurationStates.sort((state1, state2) => state2?.applicationStartTime.getTime() - state1?.applicationStartTime.getTime());
      const latestSuccessfulState = sortedConfigurationStates
      .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
      this.releasePackage = this.configurations?.find(item => item.id === latestSuccessfulState?.configurationId)?.manifest?.name;
    })
  }

  getBuildVersion(solutionVersionId: any): string {
    const solnVersion = this.serviceVersions?.find(v => v.id === solutionVersionId);
    this.solutionVersion = solnVersion;
    return solnVersion?.releaseVersion;
  }

refreshFromHeader(): void {
  this.isHeaderRefreshing = true;
  this.getInstanceDetails();
}

refreshFromOverview(): void {
  this.isLoading = true;
  this.count = this.count !== 1 ? 1 : 0;
  this.isOverviewRefreshing = true;
  this.getInstanceDetails();
}

  instanceUpdated(): void {
    this.getInstanceDetails();
  }


    redirectToJobs(data) {
      this.component = EnvironmentPages.JOBS;
      this.selectedScheduleJob = data;
      this.goToJobsPage.emit(data);
    }

    clearData(data){
      this.selectedScheduleJob = undefined;
    }

    ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'env-details-no-scroll');
  }

  /* onSwitchToOld(): void {
    this.switchToNewViewForAzure = false;
    this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, 'instance', this.instanceId]);
    // localStorage.setItem('switchTenant', JSON.stringify(this.switchToNewViewForAzure));
  } */

  getSolVersion(solutionVersionId: any): string {
    const version =  this.serviceVersions?.find(test => test.id === solutionVersionId)?.version;
    return version;
  }

  // fetch local config data
  getLocalConfiguration(): void {
    if (!this.data?.localConfigurationId) {
      this.configVersion = undefined; 
      return;
    }
    this.localConfigService.getLocalConfig(this.instanceId,this.data.localConfigurationId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(config => {
      this.configVersion = config?.version;
      if (config?.status) {
        this.data = { ...this.data, localConfigStatus: config.status };
      }
    })
  }

  /**
 * Determines which local config component to show:
 * - Shows the table view if the release version is greater or equal to the given version
 *   or if `initStatus` is 'initialised'.
 * - Otherwise, shows the alternative component.
 */
checkReleaseAndInit(version: string) {
  const releaseValid = this.isReleaseGreaterOrEqual(version);
  if (releaseValid && !this.isAWS) {
    this.showTableView = true;
    this.fetchMigrateFailed = false;
    return;
  }
  this.localConfigService.getLocalConfigurationInit(this.data?.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
    next: res => {
      this.initStatus = res?.status ?? null;
      this.showTableView = this.initStatus === DeployStatus.INITIALIZED;
      this.fetchMigrateFailed = false;
    },
    error: (error) => {
      this.initStatus = null;
      if (error?.httpStatusCode === 404 || error?.opstatus === 404) {
        this.showTableView = false;
        this.fetchMigrateFailed = false;
      } else {
        this.showTableView = false;
        this.fetchMigrateFailed = true;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
    }
  });
}

tryInitLocalConfig() {
  if (this.shouldInitLocalConfig && this.component === EnvironmentPages.LOCAL_CONFIGURATION && this.solVersion) {
    this.checkReleaseAndInit(this.solVersion);
    this.shouldInitLocalConfig = false;
  }
}

getAllFeatureByInstanceid(instanceId: string): void {
  this.featureFlagsManagerService.getAllFeatureByInstanceid(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      this.instanceFeatureResponse = response;
    });
}

}
